/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from '@/router';
import {state} from '@/store/modules/settings';

((): void => {
    // attempt to get token
    const gaToken: string|undefined = process.env.VUE_APP_GATOKEN;

    if (undefined === gaToken || !gaToken) {
        return;
    }

    const isProduction: boolean = 'production' === process.env.NODE_ENV;

    // configure analytics
    Vue.use(VueAnalytics, {
        id: gaToken,
        router,
        autoTracking: {
            exception: true,
        },
        disabled: !state.consent,
        debug: {
            enabled: !isProduction,
            sendHitTask: !isProduction,
        },
    });

})();

